// extracted by mini-css-extract-plugin
export default {"pagination":"Input_pagination__sM2Mr"};